import { Injectable, Inject,
  ComponentFactoryResolver,
  ApplicationRef, Injector,
  EmbeddedViewRef,
  OnDestroy
} from '@angular/core';
import { FormControl, FormGroup} from '@angular/forms';
import { AjaxService } from '../../services/ajax.service';
import { ModalService } from '../services/modal.service';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';
import { CountryDataService } from '../../services/country.service';
import { EmitterService } from '../../services/emitter.service';
import { GameWindowService } from '../../services/gameWindow.services';
import * as _ from 'underscore';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ZendeskService } from '../../services/zendesk.servcie';
import { language, xSaleInfoForBuumi } from './config';
import { EnvironmentService } from '../services/environment.services';
import { AppDetailsService } from '../../services/app-details.services';
declare let $: any;
// S2SaffliateIdsMap;
@Injectable()
export class Utility implements OnDestroy {
  activeGameInfo:any=null;
  allGamesData
  isGameToBeLauched:boolean = true;
  newGameUrl;
  langCode;
  destroy$: Subject<boolean> = new Subject<boolean>();
  private stateList:any={};
  private stateListQueue=[];
  private s2sEventsData = [];
  translates;
  dynamicUrl;
  websiteLangCodes;
  isMobileDepositModal=false;
  isSideMenuOpened = false;
  isHomePage: boolean = false;
  registrationPrefillingData = {};
  cashierConfigInfo;
  completeUserStatus;
  lastPlayedGames;
  isGameWindowMinimized: boolean = false;

  

  constructor(
    private ajaxService: AjaxService,
    private modalService: ModalService,
    @Inject(DOCUMENT) private doc: any,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private countryDataService: CountryDataService,
    private emitterService: EmitterService,
    private gmService: GameWindowService,
    private translate: TranslateService,
    private router:Router,
    private environmentService:EnvironmentService,
    private appDetails: AppDetailsService
  ) {
    this.websiteLangCodes = this.environmentService.getActiveLanguageConfig();
    this.translates = this.translate;
    this.langCode = localStorage.getItem("langCode");
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });

  }

  formControlToParams(values,data){
    Object.keys(values.controls).forEach(field => {
      const control = values.get(field);
      if (control instanceof FormControl) {
        data[field] = control.value;
      } else if (control instanceof FormGroup) {
        this.formControlToParams(control,data);
      }
    });
    return data;
  }
  openModal(modalId): void{
    this.modalService.open(modalId);
    ///$('#'+modalId).data('modal').options.backdrop = 'static';
  //    $('#' + modalId).modal({
  //     backdrop: 'static',
  //     keyboard: false
  //  });
  // $('#' + modalId).appendTo("body");
  }

  closeModal(modalId): void{
    this.modalService.close(modalId);
    // $(".modal").modal("hide");

 }

  closeAllOpenModel() {
    $(".modal").modal("hide");
  }

  openMultiModal(modalId) {
    $("#" + modalId).show();
    $("body").addClass("multi-modal-open");
  }

  closeMultiModal(modalId) {
    $("#" + modalId).hide();
    $("body").removeClass("multi-modal-open");
  }

  setPhoneNumberDropdown(inputId, initialSelected, form) {
    // let excludedCountries = []; //can put any country to be excluded here
    initialSelected = initialSelected ? initialSelected : "GB";
    //Sweden country restricted selecting sweden phone code
    //ND-1149 ticket number
    // if(initialSelected == "SE"){
    //   initialSelected = ''
    // }
    // excludedCountries = excludedCountries.length > 0 ? excludedCountries : (initialSelected !== 'SE' ? ["SE"] : []);
    let excludedCountries = initialSelected !== "SE" ? ["SE"] : [];
    $("#"+inputId).intlTelInput({
      initialCountry: initialSelected,
      nationalMode: false,
      excludeCountries: excludedCountries,
      preferredCountries: [],
      autoPlaceholder: false,
      separateDialCode: true
    });
    // adding autocomplete attribute to country code dropdown
    $('#phoneNumberFlag').siblings('.flag-container').attr('autocomplete', 'tel-country-code');
    $("#"+inputId).on("countrychange" ,function(e, countryData) {
      form.controls["areaCode"].setValue(countryData.dialCode);
      form.controls["areaCountryCode"].setValue(countryData.iso2.toUpperCase());
    });
  }

  validateAllFormFields(formGroup: FormGroup){
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  shouldShowErrors(controlFormNField,formName): boolean {
    let control;
    if(controlFormNField === "expMonth" || controlFormNField === "expYear"){
      if(formName.get("expDate") && formName.get("expDate").get(controlFormNField)){
        control = formName.get("expDate").get(controlFormNField);
      }
    }else{
      control = formName.controls[controlFormNField];
    }

    return control &&
    control.errors &&
    (control.dirty || control.touched);
  }


  isControlValid(controlFormNField,formName): boolean {
    let control = formName.controls[controlFormNField];
    return control && !control.errors && (control.dirty || control.touched);
  }

  getErrorMessage(controlFormNField,formName): string{
    let control;
    if(controlFormNField === "expMonth" || controlFormNField === "expYear"){
      control = formName.get("expDate").get(controlFormNField);
    }else{
      control = formName.controls[controlFormNField];
    }
    return control.errors && control.errors.message ? control.errors.message : '';
  }

  isButtonDisabled(formName):boolean{
    return formName.invalid || formName.pending;
  }
  isUserLoggedIn():boolean{
    let user = sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")): false;


      if(user){
        return true;
      }
      return false;

  }
  forgotPassword() {
    this.router.navigate([this.langCode+'/forgotpassword'],{ queryParams: { "prevUrl": 'login' }});
}

  creditCardValidation(ccNum): boolean {

    let arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
    let len = ccNum.length,
    bit = 1,
    sum = 0,
    val;
    if(len >=13 && len <= 19 ){
      while (len) {
        val = parseInt(ccNum.charAt(--len), 10);
        sum += (bit ^= 1) ? arr[val] : val;
      }
    }


    return sum && sum % 10 === 0;
  }
  resetFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.setValue(null);
      } else if (control instanceof FormGroup) {
        this.resetFormFields(control);
      }
    });
  }
  removeAllFormFieldsvalidation(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsUntouched({ onlySelf: true });
        control.markAsPristine({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.removeAllFormFieldsvalidation(control);
      }
    });
  }

  getButtonClass(formName, formSubmitted): string {
    let className = '';
    if (formName.invalid || formName.pending || formSubmitted) {
        className = 'btn-additional';
    } else if (!formName.invalid && !formName.pending ) {
      className = 'btn-primary';
    }
    return className;
  }

  getCartItemsCount(): any {
    let cartList = sessionStorage.getItem("cartList");
    if ( cartList) {
      cartList = JSON.parse(cartList);
      return Object.keys(cartList).length;
    }
  }
  hideMenu(callingFrom) {
    if (callingFrom === 'header') {
      $('.menu-items').hide();
      $('#ld_overlay').hide();
    }
  }
  scrollToPosition($target) {
    let scrollPos = $target.offset().top;
    scrollPos = scrollPos - 80;
    $("body,html").animate({scrollTop: scrollPos});
  }

  disableButton(buttonId,disabledText){
    $("#"+buttonId).prop('disabled', true);
    $("#"+buttonId).text(disabledText);
  }

  enableButton(buttonId,enableText){
     enableText ? $("#" +buttonId+ " span").text(enableText) : '';
     $("#"+buttonId).removeClass("btn-progress");
     $("#"+buttonId).children("span").show();
     $("#"+buttonId).removeAttr("disabled");
  }

   enableNewButton(id, status, enableMessage, oldMessage): void {
    enableMessage ? $("#" +id+ " span").text(enableMessage) : '';
    $("#" + id).removeClass("btn-progress");
    $("#"+id).children("span").show();
    $("#"+id).removeAttr("disabled");
    if(status === "SUCCESS") {
      $("#" + id).addClass("seablueButton");
    }else if(status === "FAILED"){
      $("#" + id).addClass("btn-failed");
    }

    setTimeout(function() {
      $("#" + id).removeClass("btn-success").removeClass("btn-failed");
      if (!oldMessage.includes("-disabledtbn")) {
        $("#" + id).prop("disabledtbn", false);
        oldMessage ? $("#" + id + " span").text(oldMessage) : '';
      } else {
        oldMessage ? $("#" + id + " span").text(oldMessage.replace("-disabledtbn", "")) : '';
      }
    }, 2000);

    $("#" + id).prop('disabledtbn', false);
    $("#" + id + " i").addClass('hide');
  }

  showError(errorDiv) {
    if ($(errorDiv).length > 0) {
      $(errorDiv).removeClass("hide");
      this.scrollToPosition($(errorDiv));
    }
  }

  curcaoEGamingInit(){
    setTimeout(() => {
      if(document.querySelector('#ceg-d23cccc9-4649-4d30-9f38-38cfa76d7243')!==null && window["ceg_d23cccc9_4649_4d30_9f38_38cfa76d7243"]){
        window["ceg_d23cccc9_4649_4d30_9f38_38cfa76d7243"].init();
      }
      else if(document.querySelector('#apg-928b8b6c-2bf6-43a3-af0a-3a8cf9dcdc4f')!==null && window["apg_928b8b6c_2bf6_43a3_af0a_3a8cf9dcdc4f"]){
        window["apg_928b8b6c_2bf6_43a3_af0a_3a8cf9dcdc4f"].init();
      }
      else if(document.querySelector('#xcm-b7c90673-1670-407d-85cb-0757359fc926')!==null && window['xcm_b7c90673_1670_407d_85cb_0757359fc926']){
        window['xcm_b7c90673_1670_407d_85cb_0757359fc926'].init();
      }
    });
  }

  gettransactionSuccessfullDeatils(txnId, depositAmount, AccountId, selectedMethod, cardNumber, txnType) {
    let length = cardNumber ? cardNumber.length : 0;
    let response = {
      ["txnId"]: txnId,
      ["amount"]: depositAmount,
      ["AccountId"]: AccountId,
      accountType: selectedMethod,
      accountNumber: cardNumber ?
      cardNumber.substring(0, (length / 4)) + "*".repeat(length - (length / 2)) + cardNumber.substring(length - 4, length) :
      'XXXXXXX',
      txnDate: new Date(),
      txnType: txnType
    };
    return response;
  }

  disableNewButton(id): void {
    $("#"+id).addClass("btn-progress").prop("disabled", true);
    $("#"+id).children("span").hide();
    if($("#"+id).children(".loader").length === 0) {
      $("#"+id).append("<div class='loader loader-white'></div>");
    }
  }


  //Get Time format
  getTime(){
    function getTime( ) {
      let d = new Date( );
      d.setHours( d.getHours()); // offset from local time
      let h = (d.getHours() % 12) || 12; // show midnight & noon as 12
      return (
        ( h < 10 ? '0' : '') + h +
        ( d.getMinutes() < 10 ? ':0' : ':') + d.getMinutes() +
                    // optional seconds display
        // ( d.getSeconds() < 10 ? ':0' : ':') + d.getSeconds() +
        ( d.getHours() < 12 ? ' AM' : ' PM' )
      );

    }


    setInterval( function() {
      let clockEleRef = document.querySelectorAll('.clock');
      if(clockEleRef.length){
        clockEleRef.forEach(element => element.innerHTML = getTime());
      }
    }, 1000 );
  }


  getStateDetails(conteryDetails){
      return new Promise((resolve,reject)=>{
        if(this.stateListQueue.length > 0){
          this.stateListQueue.push(resolve)
        }else{
          this.stateListQueue.push(resolve)
          Promise.resolve(this.ajaxService.getStates(conteryDetails))
          .then(data => {
            if(data){
              this.stateList[conteryDetails.countryCode] = data;
            }
            for(let callback in  this.stateListQueue){
                let resp_obj = Object.assign({}, this.stateList[conteryDetails.countryCode]);
                this.stateListQueue[callback](resp_obj);
            }
            this.stateListQueue = [];

          })
        }
      });
  }

  round10(value, exp):number {
    return this.decimalAdjust('round', value, exp);
  }

  roundAmount(num):number {
    return this.round10(this.round10(num * 1000, -2) / 1000, -2)
  }
  decimalAdjust(type, value, exp):number {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));

}


  setAffliateInCookie(key,affliateId):void{
          let now = new Date();
          let expTime = now.setMonth(now.getMonth()+1);// new Date(now.getFullYear(), now.getMonth()+1);


          let affliate = {
            expireTime:expTime
          };

          affliate[key]=affliateId;
          localStorage.setItem(key,JSON.stringify(affliate));
  }


  getAffliateId(key):string{
     let affData =  localStorage.getItem(key);
     if(affData){
       affData = JSON.parse(affData);
       if(affData['expireTime'] >= new Date().getTime()){
           return affData[key];
       }else{
          localStorage.removeItem(key);
          //localStorage.deleteItem('tracker');
       }
     }
     if(key === 'affiliate'){
         return "";
     }else{
         return "";
     }


  }

  setCookiePopup(cookieEnable){
    let now = new Date();
    let expTime = now.setMonth(now.getMonth()+1);
    let cookieObj = {
      cookieData:cookieEnable,
      expireTime:expTime
    };
    localStorage.setItem('enableCookie',JSON.stringify(cookieObj));
  }
  getCookiePopup() {
     let getCookie =  localStorage.getItem('enableCookie');
     if(getCookie){
       getCookie = JSON.parse(getCookie);
       if(getCookie['expireTime'] >= new Date().getTime()){
           return getCookie["cookieData"];
       }else{
          localStorage.removeItem('enableCookie');
       }
     }
     return false;
  }

  setNotifyCookie(name, hours){
    let now = new Date();
    let expTime = now.setTime(now.getTime()+(hours*60*60*1000));
    let cookieObj = {
      cookieData: name,
      expireTime: expTime
    };
    localStorage.setItem(name, JSON.stringify(cookieObj));
  }
  getNotifyCookie(name) {
     let getCookie =  localStorage.getItem(name);
     if(getCookie){
       getCookie = JSON.parse(getCookie);
       if(getCookie['expireTime'] >= new Date().getTime()){
           return getCookie["cookieData"];
       }else{
          localStorage.removeItem(name);
          return false;
       }
     }
     return false;
  }
  deleteNotifyCookie(name) {
    localStorage.removeItem(name);
  }

  gtmEvent(event,data){
    let dataLayer = window['dataLayer'] = window['dataLayer'] || [];
    dataLayer.push({
      event: event,
      attributes:data
    });
  }

  // GTM event for deposit
  depositGTMevent(typeDeposit, txId, userEcrId, amount, currency){
    this.gtmEvent(typeDeposit, {
      txnId: txId,
      userExternalECR: userEcrId,
      depositedAmount: amount,
      depositedCurrencyType: currency
    });

    if(localStorage.getItem("pnpDepositedAmount")){
      localStorage.removeItem("pnpDepositedAmount");
      localStorage.removeItem("pnpDepositedCurrency");
    }
  }

  // GTM event trusly iframe
  trustlyIframeGTMevent(iframeId){
    document.getElementById(iframeId).onload = () => {
      // console.log("Iframe Loading Complete")
      this.gtmEvent("AppLoaded", {});
    }
    // console.log("Iframe Loading Inprogress");
  }

  loadPaymentIqEncryptor(){
    const s = this.doc.createElement('script');
    s.type = 'text/javascript';
    s.src = environment.paymentIqUrl+'/api/viq/jscardencrypter/'+environment.paymentIqMID;
    $("head").append(s);
  }

  S2Scalls(userprofile,method, depositAmount?){

    if(this.getAffliateId('affiliate') && this.getAffliateId('affiliate') !="0" || (!!userprofile?.affiliateId && userprofile?.affiliateId !=0)){
      Promise.resolve(this.ajaxService.getS2SaffliateIdsMap()).then((data:any)=>{
          this.s2sEventsData = data;
          this.triggerS2SCall(method,userprofile, depositAmount);
      });
    }
  }

  triggerS2SCall(method, userprofile, depositAmount?){
    if (!userprofile){
      userprofile = {};
    }
    if (this.s2sEventsData.length > 0){
      let affliateobj =  this.s2sEventsData.filter(affObj => {
        return affObj.affiliateId
          .indexOf(String(this.getAffliateId('affiliate') !== "0" &&
            this.getAffliateId('affiliate') !== "" ?
            this.getAffliateId('affiliate') : userprofile["affiliateLinkID"])) > -1;
      });

      if(affliateobj.length<=0) return;

      if ((method === "registration" || method === "pnp") && this.doesUserHasBannerID(userprofile) && this.checkAffiliateObject("registration", affliateobj)) {
        $("body").append(affliateobj[0]["registerPixel"].replace("userInput", userprofile["bannerID"] ? userprofile["bannerID"] : userprofile["bannerId"]));
      }

      if ((method === "deposit" || method === "pnp") && this.doesUserHasBannerID(userprofile) && this.checkAffiliateObject("firstDeposit", affliateobj)) {
        if(method === "pnp") {
          userprofile["currency"] = sessionStorage.getItem("pnpUserCurrency");
          let deposit = sessionStorage.getItem("pnpUserDeposit");
          this.checkAndSendFirstDepositCall(userprofile, affliateobj, deposit, 'pnp');
        } else {
          this.checkAndSendFirstDepositCall( userprofile, affliateobj, depositAmount);
        }
      }

      if ((method === "deposit" || method === "pnp") && this.doesUserHasBannerID(userprofile) && this.checkAffiliateObject("deposit", affliateobj)) {
        if(method === "pnp") {
          userprofile["currency"] = sessionStorage.getItem("pnpUserCurrency");
          let deposit = sessionStorage.getItem("pnpUserDeposit");
          $("body").append(
            affliateobj[0]["depositPixel"]
            .replace("userInput", userprofile["bannerID"] ? userprofile["bannerID"] : userprofile["bannerId"])
            .replace("userDeposit", deposit)
            .replace("userCurrency", userprofile["currency"])
          );
        } else {
          $("body").append(
            affliateobj[0]["depositPixel"]
            .replace("userInput", userprofile["bannerID"] ? userprofile["bannerID"] : userprofile["bannerId"])
            .replace("userDeposit", depositAmount)
            .replace("userCurrency", userprofile["currency"])
          );
        }
      }


    }
    sessionStorage.removeItem("pnpUserCurrency");
    sessionStorage.removeItem("pnpUserDeposit");
    localStorage.removeItem('affiliate');
    localStorage.removeItem('tracker');
    localStorage.removeItem('cvalue');
    localStorage.removeItem('affiliatename');
  }

  async checkAndSendFirstDepositCall( userprofile, affliateobj, depositAmount, type? ) {
    let userCurrency = userprofile["currencyCode"];
    let firstDepositTagString = affliateobj[0]["firstDepositPixel"];
    let html = new DOMParser().parseFromString(firstDepositTagString, "text/html");
    let htmltag = html.body.firstElementChild;
    this.countryDataService.getEnabledCurrencies().subscribe(enabledCurrencies => {
      if (enabledCurrencies["currency"].length > 0
      && enabledCurrencies["currency"].indexOf(userCurrency) >= 0) {
        let minimumDeposit = htmltag.getAttribute(userCurrency) ?  htmltag.getAttribute(userCurrency) : 1;
        let time = 0;
        if(type === 'pnp') {
          time = 5000;
        }
        setTimeout(() => {
          this.sendFirstDepositPixel(
            userprofile,
            minimumDeposit,
            depositAmount,
            affliateobj
          );
        }, time);
      }
    });
  }

  sendFirstDepositPixel(userprofile, minimumDeposit, depositAmount, affliateobj) {

    this.ajaxService.getUserLifeTimeTransactionSummary().subscribe(data => {
      if (data["status"] === "SUCCESS" && parseFloat(minimumDeposit) &&
      parseFloat(data["successfulDepositAmountEcrCurrency"]) >= parseFloat(minimumDeposit) &&
      parseFloat(data["successfulDepositAmountEcrCurrency"]) - parseFloat(depositAmount) < parseFloat(minimumDeposit)) {
        $("body").append(affliateobj[0]["firstDepositPixel"]
        .replace("userInput", userprofile["bannerID"] ? userprofile["bannerID"] : userprofile["bannerId"])
        .replace("userDeposit", depositAmount)
        .replace("userCurrency", userprofile["currency"]));
        }
    });
  }

  doesUserHasBannerID(userprofile) {
    if (userprofile  && ( userprofile["bannerID"] || userprofile["bannerId"]) ) {
      return true;
    }
    return false;
  }

  checkAffiliateObject(method, affliateobj) {
    if (method === "registration" && affliateobj && affliateobj[0] && affliateobj[0].registerPixel) {
      return true;
    } else if (method === "firstDeposit" && affliateobj && affliateobj[0] && affliateobj[0].firstDepositPixel) {
      return true;
    } else if (method === "deposit" && affliateobj && affliateobj[0] && affliateobj[0].depositPixel) {
      return true;
    }
    return false;
  }
  removejsfile(filename, filetype) {
    let targetelement = (filetype === "js") ? "script" : (filetype === "css") ? "link" : "none" //determine element type to create nodelist from
    let targetattr = (filetype === "js") ? "src" : (filetype === "css") ? "href" : "none" //determine corresponding attribute to test for
    let allsuspects = document.getElementsByTagName(targetelement)
    for (let i = allsuspects.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove
      if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) && allsuspects[i].getAttribute(targetattr).indexOf(filename) !== -1)
        allsuspects[i].parentNode.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
    }
  }
  searchjsfile(filename, filetype) {
    let targetelement = (filetype === "js") ? "script" : (filetype === "css") ? "link" : "none" //determine element type to create nodelist from
    let targetattr = (filetype === "js") ? "src" : (filetype === "css") ? "href" : "none" //determine corresponding attribute to test for
    let allsuspects = document.getElementsByTagName(targetelement)
    for (let i = allsuspects.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove
      if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) && allsuspects[i].getAttribute(targetattr).indexOf(filename) !== -1)
        return true;
    }
    return false;
  }
  loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  // Dynamic component
  addDynamicComponent(element, component) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
    const componentRef = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    if (element.childNodes[0]) {
      element.replaceChild(domElem, element.childNodes[0]);
    } else {
      element.appendChild(domElem);
    }
  }

  inViewport(ele) {
    if(!ele) return false;
    let box = ele.getBoundingClientRect();
    return box.top < window.innerHeight && box.bottom >= 0;
  }

  parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }

  modifyUserData(signUpData){

    if(signUpData['zip']) signUpData["zipCode"] = signUpData['zip'];
    if(signUpData['country']) signUpData["countryCode"] = signUpData['country'];
    if(signUpData["phone"]) signUpData["phoneNumber"] = signUpData["phone"];
    if(signUpData["currency"]) signUpData["currencyCode"] = signUpData["currency"];
    signUpData["dob"] = signUpData['bYear']+"-"+('0' + parseInt(signUpData['bMonth'])).slice(-2)+"-"+('0' + parseInt(signUpData['bDay'])).slice(-2);

    delete signUpData["zip"];
    delete signUpData["country"];
    delete signUpData["phone"];
    delete signUpData["currency"];
    delete signUpData["bYear"];
    delete signUpData["bMonth"];
    delete signUpData["bDay"];

    return signUpData;
  }

  checkGameDataToSetMetaData() {
    let allGamesData = this.gmService.getAllSlotData();
    let activeGameInfo = this.getActiveGameInfo();
    if(activeGameInfo && activeGameInfo['gameId']){
      if(allGamesData && allGamesData.length > 0){
        this.updateGameWindowMetadata(allGamesData)
      }else{
        this.gmService.getAllCasinoGames().subscribe(allGamesResp => {
          this.updateGameWindowMetadata(allGamesResp);
        });
      }
    }
  }

  updateGameWindowMetadata(allGamesResp){
    let activeGameInfo = this.getActiveGameInfo();
    if(activeGameInfo && activeGameInfo['gameId']){
      let launchedGameObj = _.findWhere(allGamesResp, {gameCode: activeGameInfo.gameId});
      if(launchedGameObj && !(_.isEmpty(launchedGameObj))) {
        this.emitterService.broadCastUpdateMetaInfo({title:launchedGameObj['metaTitle'], keywords:launchedGameObj['metaTags'], description:launchedGameObj['metaDescription']});
      }
    }
  }

  setActiveGameInfo(info){
    this.activeGameInfo=info;
    this.emitterService.broadCastUpdatedActiveGameInfo(this.activeGameInfo);
  }

  getActiveGameInfo(){
    return this.activeGameInfo;
  }

  setIsGametoBeLaunched(isTobeLaunched) {
    this.isGameToBeLauched = isTobeLaunched;
  }

  getIsGametoBeLaunched() {
    return this.isGameToBeLauched;
  }



  changeGameUrlByLangCode() {
    let gameInfo = this.getActiveGameInfo();
    let currentGameUrl = gameInfo.gameLaunchUrlPath;
    let allGamesData = this.gmService.getMultiLingualGameObj();
    /* ND-439 multilingual game launch changes can be modified here */
    this.newGameUrl = allGamesData[currentGameUrl]['multilingualUrl']['en'] ? allGamesData[currentGameUrl]['multilingualUrl']['en'] : allGamesData[currentGameUrl].gameCode;
    window.location.href = window.location.origin + "/" + this.langCode + "/gameplay/" + this.newGameUrl;
  }

  reloadPage() {
    setTimeout(_ => {
      if(window.location.pathname.includes("gameplay")) {
        this.changeGameUrlByLangCode();
      } else {
        window.location.reload();
      }
    });
  }

  showSearchBar() {
    this.emitterService.broadCastShowSearchBar(true);
    setTimeout(() => {
      $("#searchInput").focus();
    });
  }

  setDynamicUrlHref() {
    let urlSlug = window.location.pathname.substring(3);
    let lang = localStorage.getItem('langCode')
    if (urlSlug.length > 1) {
      this.dynamicUrl = '/'+ lang + '' + urlSlug;
    } else if (window.location.pathname.length === 3 && _.contains(this.websiteLangCodes, lang)) {
      this.dynamicUrl = '/'+ lang;
    }
  }
  getActualMappedLanguage(lang = null){
    if(!lang){
      lang = localStorage.getItem('langCode');
    }
    if(lang && environment.specifiedMappedLanguages[lang] ){
       return environment.specifiedMappedLanguages[lang];
    }else{
      return localStorage.getItem('langCode') ? localStorage.getItem('langCode') : 'en';
    }
  }
  mappedLanguageCodes() {
     return this.websiteLangCodes;
  }

  getDynamicUrlHref() {
    return this.dynamicUrl;
  }

  preventDefaultEvent(evtParam){
    evtParam.preventDefault();
  }

  goToCompleteProfile(isMyAccount = false){
    this.setIsSideMenuOpened(false);
    this.emitterService.broadCastToggleNavPanel(false);
    this.emitterService.broadcastRouteChange(true);
    this.disablescrollOnRegistrationPageOpend(true);
  }
   navigateToFoo(){
     this.router.navigate([], {
      queryParams: {
        page: 'step2'
      },
      queryParamsHandling: '',
    });
   }
   //remove specific params based on the PARAMS object recived
   removeParam(params){
    this.router.navigate([], {
      queryParams: params,
      queryParamsHandling: ''
    })
  }
  getOsBrowserType() {
    let doc:any = document;
    if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 )
   {
      return 'Opera';
   }
   else if(navigator.userAgent.indexOf("Edg") != -1 )
   {
      return 'Edge';
   }
   else if(navigator.userAgent.indexOf("Chrome") != -1 )
   {
       return 'Chrome';
   }
   else if(navigator.userAgent.indexOf("Safari") != -1)
   {
       return 'Safari';
   }
   else if(navigator.userAgent.indexOf("Firefox") != -1 )
   {
        return 'Firefox';
   }
   else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!doc.documentMode == true )) //IF IE > 10
   {
      return 'IE';
   }
   else
   {
      alert('unknown');
   }
   }
   getGroupBy(payload,key){
    return _.groupBy(payload,key)
  }
//BMI X Sale from KOI
  goToXSaleSite(){
    this.closeModal("swedishModal");
    let userAffId = this.getAffliateId('affiliate');
    let xSaleRedirectionLink = xSaleInfoForBuumi.encoded;
    if(userAffId && userAffId != '0'){
        xSaleRedirectionLink = xSaleInfoForBuumi.siteNameWithAffId+userAffId;
    }
    window.location.href = xSaleRedirectionLink;
  }

  setIsSideMenuOpened(isSideMenuOpened){
    this.isSideMenuOpened = isSideMenuOpened;
  }

  getIsSideMenuOpened(){
    return this.isSideMenuOpened;
  }

  setIsHomePage(isHomePage){
    this.isHomePage = isHomePage;
  }

  getIsHomePage(){
    return this.isHomePage;
  }
  clearGamesAndLobbysData(){
    this.gmService.clearGamesAndLobbies()
  }
  updateProfileLangCode(userDetail,completeUserStatus, isFromUrl=false) {
    if (completeUserStatus["userProfileCompleted"] && userDetail) {
      let signUpData = {};
      signUpData = userDetail;
      signUpData["language"] = language[this.langCode];
      signUpData = this.modifyUserData(signUpData);
      Promise.resolve(this.ajaxService.doProfileUpdate(signUpData)).then(
        (res:any) => {
         if(res.status == 'SUCCESS')
          localStorage.setItem("langCode",this.langCode); /* setting userlancode when user is loggedin and update language through dropdown */
          if(!isFromUrl){
            this.reloadPage();
          }

        }
      );
    } else {
      if(!isFromUrl){
        this.reloadPage()
      }
    }
}
  registrationCaptureRouteData(){
    if(location.href.includes('=') && location.href.includes('?')){
      let registerDataObj = location.search.replace('?','').split('&');
      this.registrationPrefillingData = {}
      if(registerDataObj && registerDataObj.length){
        registerDataObj.forEach((obj)=>{
          if(obj && obj.includes('=')){
             let data = obj.split('=');
             this.registrationPrefillingData[data[0]] = data[1]
          }
        })
      }
      localStorage.setItem('regPreData',JSON.stringify(this.registrationPrefillingData))
    }
  }
  isMobile(){
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      return true;
    }
    return false;
  }
  isDeviceBelowe_480(){
    const ww = document.body.clientWidth;
    if (ww <= 480) {
      return true;
    }
    return false;
  }
  isRegisterPage(){
    if(location.pathname.includes('/register')){
      return true;
   }
   return false;
  }
  disablescrollOnRegistrationPageOpend(isDisabled=false){
    if(this.isMobile() && isDisabled){
      document.body.style.overflow = 'hidden';
    }else{
      document.body.style.overflow = '';
    }
  }
  isBritplay(){
    if(this.countryDataService.ipCountry &&environment.zimplerCountries.indexOf(this.countryDataService.ipCountry)){
      return true
    }
    return false;
  }

  setCaretToEnd(target/*: HTMLDivElement*/) {
    const range = document.createRange();
    const sel = window.getSelection();
    range.selectNodeContents(target);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
    target.focus();
    range.detach(); // optimization

    // set scroll to the end if multiline
    target.scrollTop = target.scrollHeight;
  }
  
 

 //game launcher code

 movetoLogin(gameId, gameLaunchUrlPath) {
  this.closeModal("mobileGame");
  this.appDetails.setGameLauncherParams(gameId, gameLaunchUrlPath);
  this.router.navigate([this.langCode + '/login']);
}

gameLauncher(gameType,game, userService, gamingUtils): void {
  this.emitterService.broadCastShowSearchBar(false);
  // this.setIsGameWindowMinimized(false)
  this.gmService.forceLatestPlayedGames = true;
  if((gameType === 'real' && this.isUserLoggedIn()) || (gameType === 'imageClick' && this.isUserLoggedIn()) || gameType === 'demo'){
    /* ND-439 multilingual game launch changes can be modified here */
    this.setIsGameWindowMinimized(false)
    userService.gamePlayLaunchChecks(game.gameCode, game['multilingualUrl']['en']);
  } else if(gameType === 'imageClick' && this.isMobile()) {
    this.setIsGameWindowMinimized(false)
    this.emitterService.broadCastIsGameModal(true);
    gamingUtils.setGameDetails(game);
  } else {
    /* ND-439 multilingual game launch changes can be modified here */
    this.movetoLogin(game.gameCode, game['multilingualUrl']['en'])
  }
}

setFavouriteGames(gameId, isFavourite) {
  let newState = isFavourite ? false : true;
  this.ajaxService.setFavouriteGames(newState, gameId).then(response => {
    if(response["status"] === "SUCCESS") {
      isFavourite = response["favoriteAddFlag"];
      this.emitterService.broadCastFavouriteGames(true);
    }
  });
}

trimNumberBasedOnCountryRequirement(ipCountry, signUpData){
  let trimmedPhoneNumber = '';
    let phoneNumber = String(signUpData.phoneNumber);
    if(ipCountry == "SE"){
    const indexOfSeven = phoneNumber.indexOf("7");
      if(indexOfSeven > 0){
        trimmedPhoneNumber = phoneNumber.slice(indexOfSeven)
      }else{
        trimmedPhoneNumber = phoneNumber;
      }
    }else{
      trimmedPhoneNumber = phoneNumber
    }
    return trimmedPhoneNumber;
  }
  // showFooterAfterScroll(){
  //   const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  //   if (isSafari) {
  //     setTimeout(function(){
  //       window.scrollTo(0, 1);
  //     },500);
  //   }
  // }

  trimNumberForSwedenValidation(number){
    let trimmedPhoneNumber = '';
    let phoneNumber = String(number);
    const indexOfSeven = phoneNumber.indexOf("7");
    if(indexOfSeven > 0){
        trimmedPhoneNumber = phoneNumber.slice(indexOfSeven)
    }else{
        trimmedPhoneNumber = phoneNumber;
    }
      return trimmedPhoneNumber
  }

  getIsGameWindowMinimized(){
    return this.isGameWindowMinimized;
  }

  setIsGameWindowMinimized(isMinimized){
      this.isGameWindowMinimized = isMinimized;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}

